var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-type-stats",staticStyle:{"width":"100%"}},[_c('div',{ref:"blueDom",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"blueChartDom"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }